import type { BrowseItem } from '../fileBrowser/fileBrowserApi';
import { getMediaKind } from './mediaFileTypes';

export interface MediaGalleryItem {
  name: string;
  path: string;
}

/** Parent directory path for a relative file path (empty string when at mount root). */
export function parentDirectoryPath(relativePath: string): string {
  const normalized = relativePath.replace(/\\/g, '/').replace(/^\/+/, '');
  const lastSlash = normalized.lastIndexOf('/');
  return lastSlash >= 0 ? normalized.slice(0, lastSlash) : '';
}

/** Filter folder items to previewable images (SVG excluded via getMediaKind). */
export function filterImageItems(items: readonly BrowseItem[]): MediaGalleryItem[] {
  return items
    .filter((item) => !item.isDirectory && getMediaKind(item.name) === 'image')
    .sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }))
    .map((item) => ({ name: item.name, path: item.path }));
}

export function buildImagePlaylist(items: readonly BrowseItem[]): MediaGalleryItem[] {
  return filterImageItems(items);
}

function normalizeGalleryPath(path: string): string {
  return path.replace(/\\/g, '/').replace(/^\/+/, '');
}

export function playlistIndexOf(playlist: readonly MediaGalleryItem[], path: string): number {
  const target = normalizeGalleryPath(path);
  return playlist.findIndex((item) => normalizeGalleryPath(item.path) === target);
}

export function playlistNext(
  playlist: readonly MediaGalleryItem[],
  currentPath: string
): MediaGalleryItem | null {
  const index = playlistIndexOf(playlist, currentPath);
  if (index < 0 || index >= playlist.length - 1) return null;
  return playlist[index + 1];
}

export function playlistPrev(
  playlist: readonly MediaGalleryItem[],
  currentPath: string
): MediaGalleryItem | null {
  const index = playlistIndexOf(playlist, currentPath);
  if (index <= 0) return null;
  return playlist[index - 1];
}
